/// <amd-module name="Feed/CreateFeed/Services/CreateFeedService" />
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";

import { Feed, FeedPermission, FeedView } from "Feed/Common/Contracts/Feed";
import { getFeedClient, IFeedRestClient } from "Feed/Common/RestClient/Feed";
import { ICreateFeedService } from "Feed/CreateFeed/Types";

export class CreateFeedService extends VssService implements ICreateFeedService {
    private _feedRestClient: IFeedRestClient;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        this._feedRestClient = getFeedClient(pageContext);
    }

    public async createFeedAsync(feed: Feed): Promise<Feed> {
        const projectId = feed.project ? feed.project.id : undefined;
        return this._feedRestClient.createFeed(feed, projectId);
    }

    public async setFeedViewPermissionsAsync(
        feed: Feed,
        viewId: string,
        feedPermissions: FeedPermission[]
    ): Promise<FeedPermission[]> {
        const projectId = feed.project ? feed.project.id : undefined;
        const feedId = feed.id + "@" + viewId;
        return this._feedRestClient.setFeedPermissions(feedPermissions, feedId, projectId);
    }

    public async updateFeedViewAsync(feed: Feed, view: FeedView, viewId: string): Promise<FeedView> {
        const projectId = feed.project ? feed.project.id : undefined;
        return this._feedRestClient.updateFeedView(view, feed.id, viewId, projectId);
    }

    public getFeedPermissionsAsync(
        feed: Feed,
        includeIds?: boolean,
        excludeInheritedPermissions?: boolean,
        identityDescriptors?: string
    ): Promise<FeedPermission[]> {
        const projectId = feed.project ? feed.project.id : undefined;
        return this._feedRestClient.getFeedPermissions(
            feed.id,
            projectId,
            includeIds,
            excludeInheritedPermissions,
            identityDescriptors
        );
    }
}

Services.add("ICreateFeedService", { serviceFactory: CreateFeedService });
